import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { OrgJed } from './orgjed';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-orgjed-modal-update',
  templateUrl: './orgjed-modal-update.component.html'
})
export class OrgJedModalUpdateComponent extends BaseModalUpdateComponent<OrgJed> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OrgJed>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
